<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page container" v-else-if="loaded" >
        
        <div class="mt-3" >
            <ul class="horizontal-menu " > 
                <li>  <router-link :to="{name: 'Integration', params: { APP: 'ACTIVECAMPAIGN' } }" class="not-active pl-0" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>  </li>
            </ul>
        </div>
        
        <div class="row mt-3" >
            
            <b-form  @submit.prevent="submit" class="atlass-form col-12 mt-3 " >
                
                <div class="col-12 border-bottom-gray pb-2 mb-3" >
                    <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Integration details </h2> </span>
                    <span class="d-inline-block float-right" > 
                        
                        <span v-if="data.last_update" class="font-300 font-size-14 line-height-31 mr-2" > Last updated at: <b > {{formatData(data.last_update)}} </b> </span>
                        
                        <b-dropdown v-if="!editable"  size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14">
                            <b-dropdown-item-button @click="edit"  >Edit</b-dropdown-item-button>
                            <b-dropdown-item-button v-if="data.Status" @click="toggleSwitch( 'Status', false )"   >Deactivate</b-dropdown-item-button>
                            <b-dropdown-item-button v-else-if="!data.Status" @click="toggleSwitch( 'Status', true )"  >Activate</b-dropdown-item-button>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item-button variant="danger" @click="preventDelete()" >Delete</b-dropdown-item-button>
                        </b-dropdown>
                        
                        <span v-else-if="editable" >
                            <b-button type="submit" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                            <b-button @click="edit" v-if="ID != 'new'" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
                        </span>
                    </span>
                </div>
                
                 <div class="col-12 form-group" >
                     <b-form-group >
                        <label> Name: </label>
                        <span v-if="!editable" class="font-weight-bold" > {{data.Name}} </span>
                        <b-form-input v-else-if="editable" id="NameInput"
                        type="text"
                        v-model="data.Name"
                        required
                        placeholder="Name">
                        </b-form-input>
                    </b-form-group>
                </div>
                
                 <div class="col-12 form-group" >
                     <b-form-group >
                        <label> Active Campaign account name: </label>
                        <span v-if="!editable" class="font-weight-bold" > {{data.ACTIVECAMPAIGN_accountname}} </span>
                        <b-form-input v-else-if="editable" id="accountnameInput"
                        type="text"
                        v-model="data.ACTIVECAMPAIGN_accountname"
                        required
                        placeholder="Account name">
                        </b-form-input>
                    </b-form-group>
                </div>
                
                 <div class="col-12 form-group" >
                     <b-form-group >
                        <label> Active Campaign  API key: </label>
                        <span v-if="!editable" class="font-weight-bold" > {{data.ACTIVECAMPAIGN_apiKey}} </span>
                        <b-form-input v-else-if="editable" id="apiKeyInput"
                        type="text"
                        v-model="data.ACTIVECAMPAIGN_apiKey"
                        required
                        placeholder="API key">
                        </b-form-input>
                    </b-form-group>
                </div>
                
                <div class="col-12  form-group" v-if="ID != 'new'" >
                     <b-form-group >
                        <label> Status: </label>
                        <span v-if="!editable" >
                            <b v-if="data.Status == 1" > Active </b>
                            <b v-else-if="data.Status == 0"  > Inactive </b>
                        </span>
                         
                        <div v-else-if="editable" >
                            <b-form-checkbox v-model="data.Status" name="check-button" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                            <span v-if="data.Status" > Active </span>
                            <span v-else-if="!data.Status" > Inactive </span>
                        </div>
                         
                    </b-form-group>
                </div>
                
                <div class="col-12 col-md-6 form-group" v-if="data.last_update" >
                     <b-form-group >
                        <label> Last update: </label>
                        <span >
                            <b > {{formatData(data.last_update)}} </b>
                        </span> 
                    </b-form-group>
                </div>

            </b-form>
            
            <div class="alert alert-info m-3" v-if="ID == 'new'" >
                
                To integrate your Active Campaign account, after logging in, go to Settings -> Developer and past in your account name and API key.
                <br><br>
                Your account name is the first part of the URL used to access your account: https://accountname.activehosted.com. 
                This can be also found on the developer page, inside the API Access URL: https://accountname.api-us1.com
                
                <br><br>
                The API Key can be found on the Developer page.
                <br><br>
                Add the detailes above and click save
                
            </div>
            
        </div>
        
        <div class="row mt-4 mb-5 font-size-14" v-if="type == 'edit' && data.Status == 1" >
    
            <div class="col-12 " >
                
                <div class="col-12 border-bottom-gray pb-2 mb-4" >
                    <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Integration settings </h2> </span>
                </div>

                <div class="col-12 mt-3" >
                    <div class="row" >
                        <div class="col-12 col-md-10" >
                            <h2 class="h3 font-weight-bold line-height-31" > Attribute campaigns </h2>
                            <p class="mt-1" >
                                This action will get and list all campaigns from your Active Campaign account
                            </p>
                        </div>
                        <div class="col-12 col-md-2 text-right" >
                            <b-form-checkbox v-model="data.settings.attribute_campaigns" name="check-button" @change="toggleSwitch( 'attribute_campaigns', data.settings.attribute_campaigns )" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                            <span v-if="data.settings.attribute_campaigns" > Active </span>
                            <span v-else-if="!data.settings.attribute_campaigns" > Inactive </span>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 mt-4 d-none" >
                    <div class="row" >
                        <div class="col-12 col-md-10" >
                            <h2 class="h3 font-weight-bold line-height-31" > Automation Rules </h2>
                            <p class="mt-1" >
                                Set a rule when a lead is applied a tag inside Atlass, you can also apply a tag inside Active Campaign to retarget him.
                                Make sure you have permissions to email them.
                            </p>
                            <div class="mt-2" v-if="data.settings.sync_leads" >
                                 
                                <div v-if="!data.automation_rules || ( data.automation_rules && data.automation_rules.length == 0 )" class="text-center alert alert-info" > You don't have any rules. Set up one now </div>
                                
                                <div class="row mt-4" >
                                    
                                    <!-- v-for="(item, index) in data.automation" v-if="data.automation_rules.length == 0"  -->
                                    
                                    <div class="col-12" v-for="(item, index) in data.automation_rules" v-if="data.automation_rules.length > 0" >
                                        If 
                                        <span class="mr-2 ml-2 border-bottom-gray p-1 pl-3 pr-3 box-span font-size-14" > {{ item.tag }} </span>
                                        is added to a Atlass lead, apply 
                                        <span class="mr-2 ml-2 border-bottom-gray p-1 pl-3 pr-3 box-span font-size-14" > {{ item.ac_tag }} </span>
                                        to Active Campaign contact. 
                                        <font-awesome-icon :icon="['fa', 'trash']" class="ml-2 cursor-pointer" @click="deleteAutomationRule( index )" /> 
                                    </div>
                                    
                                    
                                    <div class="col-12 mt-3"  >
                                        If 
                                        <input type="text" v-model="newrule.tag" class="form-control d-inline-block w-auto ml-2 mr-2" style="height: 28px;" /> 
                                        is added to a Atlass lead, apply 
                                        <input type="text" v-model="newrule.ac_tag" class="form-control d-inline-block w-auto  ml-2 mr-2" style="height: 28px;" /> 
                                        to Active Campaign contact. 
                                        <button @click="addAutomationRule( newrule )" class="btn btn-primary btn-sm" > Add rule </button>
                                    </div>
                                    
                                </div>
                                                          
                            </div>
                        </div>
                        <div class="col-12 col-md-2 text-right" >
                            <b-form-checkbox v-model="data.settings.sync_leads" name="check-button" @change="toggleSwitch('sync_leads', 'data.settings.sync_leads')"  class="cursor-pointer d-inline " switch > </b-form-checkbox>
                            <span v-if="data.settings.sync_leads" > Active </span>
                            <span v-else-if="!data.settings.sync_leads" > Inactive </span>
                        </div>
                    </div>
                </div>
    
            </div>
    
            <div class="col-12 mt-5" >
                
                <div class="col-12 border-bottom-gray pb-2 mb-4" >
                    <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Actions </h2> </span>
                </div>

                <div class="col-12 mt-3" >
                    <div class="row" >
                        <div class="col-12 col-md-10" >
                            <h2 class="h3 font-weight-bold line-height-31" > Test the integration  </h2>
                            <p class="mt-1" >
                                This action will perform a test to see if the integration is up and running.
                            </p>
                        </div>
                        <div class="col-12 col-md-2 text-right" >
                            <b-button v-if="allowTestIntegration" @click="testIntegration" variant="outline-secondary" class="btn btn-sm" > Run test </b-button>
                        </div>
                    </div>
                </div>
    
            </div>
            
        </div>
        
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'ACTIVECAMPAIGN',
    components:{
        
    },
    props: {
        ID:{
            type: [String]
        }
    },
    data: function(){
        return {
            loaded: false, 
            data:{
                Name: "Active Campaign Integration",
                Tag: "!activecampaign",
                ACTIVECAMPAIGN_accountname: "",
                ACTIVECAMPAIGN_apiKey: "",
                Status: true,
                contact_tag: 'atlass'
            },
            type: 'add',
            editable: false,
            allowTestIntegration: false,
            
            newrule:{
                tag: "",
                ac_tag: ""
            }
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {      
        if( this.ID == 'new' ){
            this.loaded = true
            this.editable = true
        }else{
            this.get_data( this.ID );
        }
        
    },
    beforeDestroy() {
    },
    methods: {
         get_data( ID ){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/integrations').doc( ID )
                                    
            return ref.get()
                .then((snapshot) => {
                    if( !snapshot.empty ){
                        console.log(snapshot.data())
                        this.data = snapshot.data()
                        this.data.docID = snapshot.id
                        this.type = 'edit'
                        this.allowTestIntegration = true
                        this.editable = false
                    }else{
                        console.log("No integration set")
                    }
                        
                    this.loaded = true;
                    //this.getOrg()
                })
          
        },
        getOrg(){
          
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )
                        
            const db = firebase.firestore();
            var ref = db.collection('organizations').doc( user.organizationID )
            
            return ref.get()
                .then((snapshot) => {
                    console.log(snapshot.data())
                    this.org = snapshot.data()
                    this.org.id = snapshot.id
                
                    this.loaded = true;
                })
          
        },
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        edit(){
            this.editable = !this.editable
        },
        
        submit(){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            const db = this.$firebase.firestore();
            
            let document = {
                    "APPKEY": orgID,
                    "APP": "ACTIVECAMPAIGN",
                    "Name" : this.data.Name,
                    "Type" : 'email',
                    //"tag" : this.data.tag,
                    "ACTIVECAMPAIGN_accountname": this.data.ACTIVECAMPAIGN_accountname,
                    "ACTIVECAMPAIGN_apiKey": this.data.ACTIVECAMPAIGN_apiKey,
                    "Status": this.data.Status,
                    "contact_tag": this.data.contact_tag
                }
            
            //console.log(document)
            
            if( this.type == 'add' ){
                let settings = {}
                settings.attribute_campaigns = true
                settings.sync_leads = false

                document.settings = settings
                
                document.datetime = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/integrations')
                
                return ref.add( document )
                 .then((result)=>{
                    
                    this.get_data(result.id)
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Integration successfully created'
                    })
                    
                    this.loaded = true
                    
                })
                
            }else{
                
                document.last_update = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )
                
                return ref.set( document, { merge: true } )
                .then((result)=>{
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                    
                    this.loaded = true
                    this.editable = false
                    
                })
                
            }

            
        },
        testIntegration(){
            let params = Cookies.get('user-token')
            //let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "integrationID": this.data.docID }
            //let data = JSON.stringify( this.newOrg )/
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/activecampaign/getcampaigns', headers: headers, data: data })
                .then(resp => {
                                
                if( resp.status == 200 ){
                    let r = resp.data;
                    
                    //console.log(r)
                    if( r.status == 100 ){
                        this.$toast.success({
                            title:'Success',
                            //message: "Active Campaign has been succsesfully integrated"
                            message: r.body
                        })
                    }else{
                        this.$toast.error({
                            title:'Warning',
                            //message: "Active Campaign has been succsesfully integrated"
                            message: r.body
                        })
                    }
                    
                        
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
        },
        
        toggleSwitch( field, value ){
            let document = {}
            let update = true;
            
            console.log(this.data)
            
            if( field == 'Status' ){
                this.data.Status = value
                document.Status = value
            }else if( field == 'sync_leads' ){
                let settings = {}
                settings.sync_leads = this.data.settings.sync_leads
                document['settings.sync_leads'] = !this.data.settings.sync_leads
                
                if( !this.data.settings.sync_leads ){
                    //update = false
                    update = true
                }else{
                    update = true
                }
                
            }else if( field == 'attribute_campaigns' ){
                document['settings.attribute_campaigns'] = !this.data.settings.attribute_campaigns
            }else if( field == 'contact_tag' ){
                if( this.data.contact_tag == '' ){
                    //this.data.settings.sync_leads = false
                    this.data.contact_tag = null
                }
                document['settings.sync_leads'] = this.data.settings.sync_leads
                document.contact_tag = this.data.contact_tag
            }
            
            document.last_update = Math.round(+new Date()/1000)
            
            if( update ){
                //UPDATE FIRESTORE
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                const db = this.$firebase.firestore();
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

                return ref.update( document )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                })
            }
            
        },//end toggleSwitch
        
        preventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete( );
                    
                }
            })
            
        },        
        delete: function( ){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.ID )
            return ref.delete()
            .then(function(){

                 this.$toast.success({
                    title: 'Success',
                    message: 'Integration deleted'
                })

                setTimeout(function(){ 
                    this.loaded = true
                    this.$router.push({
                        name: 'Integrations'
                    }); 
                }.bind(this), this.timeout );

            }.bind(this))
            .catch(function(error){

                //console.error("Error updating document: ", error);
                this.$toast.error({
                    title: 'Error',
                    message: "Something went wrong: "+error
                })

                this.loaded = true

            }.bind(this))
            
        },
        
        addAutomationRule( rule ){
            
            if( !this.data.automation_rules ){
                this.data.automation_rules = []
            }
                        
            if( rule.tag == "" || rule.ac_tag == "" ){
                this.$toast.error({
                    title:'Warning',
                    message: 'Please make sure you set both tags for the automation rule'
                })
                return false
            }
            
            
            this.data.automation_rules.push( { tag: rule.tag, ac_tag: rule.ac_tag } )
            
            this.newrule.tag = ""
            this.newrule.ac_tag = ""
            
            this.$toast.success({
                title:'Success',
                message: 'Rule added'
            })
            
            let document = this.data
            document.last_update = Math.round(+new Date()/1000)
                    
            let ref = this.$firebase.firestore().collection('organizations/'+helper.getLoggedInOrganization( this.$store.getters.isAdmin )+'/integrations').doc( this.data.docID )

            return ref.set( document, { merge: true } )
            .then((result)=>{

                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved '
                })

            })
            
        },
        
        deleteAutomationRule( i ){
            
            this.data.automation_rules.splice(i, 1);
            
            let document = this.data
            document.last_update = Math.round(+new Date()/1000)
                    
            let ref = this.$firebase.firestore().collection('organizations/'+helper.getLoggedInOrganization( this.$store.getters.isAdmin )+'/integrations').doc( this.data.docID )

            return ref.set( document, { merge: true } )
            .then((result)=>{

                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved '
                })

            })
        }
        
    },
    watch: {
        ID: function(){
            this.docID = this.ID
            this.get_data();
            
            this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/integrations/ACTIVECAMPAIGN.vue